/**
 * Badge Component Styles
 */

import { mode } from '../../system/color-mode';

export const badgeStyles = {
  baseStyle: {
    borderRadius: '10px',
    lineHeight: '100%',
    padding: '7px',
    paddingLeft: '12px',
    paddingRight: '12px',
    fontWeight: 'bold',
    textTransform: 'uppercase',
    fontSize: 'xs',
  },

  variants: {
    // Solid (default)
    solid: (props) => ({
      bg: `${props.colorScheme || 'gray'}.500`,
      color: 'white',
    }),

    // Subtle
    subtle: (props) => ({
      bg: mode(
        `${props.colorScheme || 'gray'}.100`,
        `${props.colorScheme || 'gray'}.800`
      )(props),
      color: mode(
        `${props.colorScheme || 'gray'}.800`,
        `${props.colorScheme || 'gray'}.100`
      )(props),
    }),

    // Outline
    outline: (props) => ({
      borderRadius: '16px',
      color: `${props.colorScheme || 'gray'}.500`,
      boxShadow: `inset 0 0 0px 1px ${props.colorScheme || 'gray'}.500`,
      bg: 'transparent',
    }),

    // Brand (project custom)
    brand: (props) => ({
      bg: mode('brand.500', 'brand.400')(props),
      color: 'white',
      _focus: {
        bg: mode('brand.500', 'brand.400')(props),
      },
      _active: {
        bg: mode('brand.500', 'brand.400')(props),
      },
      _hover: {
        bg: mode('brand.600', 'brand.400')(props),
      },
    }),
  },

  defaultProps: {
    variant: 'subtle',
    colorScheme: 'gray',
  },
};

export default badgeStyles;
